const Loader = () => {
  return (
    <div className="w-full h-screen overflow-auto bg-gray-50">
      {/* Weekly Stats Skeleton */}
      <div className="bg-white border-b border-gray-200 shadow-sm">
        <div className="max-w-7xl mx-auto px-3 sm:px-4 md:px-6 py-3 sm:py-4">
          {/* Header Skeleton */}
          <div className="mb-4 sm:mb-5">
            <div className="relative bg-gradient-to-r from-orange-50 via-amber-50/30 to-orange-50 rounded-2xl p-4 sm:p-5 border border-orange-100/50 shadow-sm">
              <div className="flex items-center justify-between">
                {/* Logo Skeleton */}
                <div className="w-14 h-14 sm:w-16 sm:h-16 rounded-xl skeleton-shimmer"></div>
                
                {/* Title Skeleton */}
                <div className="flex-1 flex flex-col items-center justify-center mx-4">
                  <div className="h-6 sm:h-7 w-48 rounded-lg skeleton-shimmer mb-2"></div>
                  <div className="h-4 w-32 rounded skeleton-shimmer"></div>
                </div>
                
                {/* Button Skeleton */}
                <div className="w-10 h-10 rounded-xl skeleton-shimmer"></div>
              </div>
            </div>
          </div>

          {/* Location Switcher Skeleton */}
          <div className="mb-3 sm:mb-4">
            <div className="flex gap-2 overflow-x-auto pb-2">
              {[1, 2, 3, 4].map((i) => (
                <div
                  key={i}
                  className="flex-shrink-0 h-10 w-24 rounded-lg skeleton-shimmer"
                  style={{ animationDelay: `${i * 150}ms` }}
                ></div>
              ))}
            </div>
          </div>

          {/* KPI Cards Grid Skeleton */}
          <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-2 sm:gap-3 mb-2 sm:mb-3">
            {[1, 2, 3, 4].map((i) => (
              <div
                key={i}
                className="bg-white border border-gray-200 rounded-lg p-2 sm:p-3 shadow-sm"
              >
                <div className="flex items-center justify-between mb-1.5">
                  <div className="w-7 h-7 sm:w-8 sm:h-8 rounded-full skeleton-shimmer"></div>
                </div>
                <div className="h-3 w-24 rounded skeleton-shimmer mb-2"></div>
                <div className="h-8 w-16 rounded skeleton-shimmer mb-1"></div>
                <div className="h-3 w-32 rounded skeleton-shimmer"></div>
              </div>
            ))}
          </div>

          {/* Additional Stats Grid Skeleton */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-2 sm:gap-3">
            {[1, 2, 3, 4, 5].map((i) => (
              <div
                key={i}
                className="bg-white border border-gray-200 rounded-lg p-2 sm:p-3 shadow-sm"
              >
                <div className="h-3 w-20 rounded skeleton-shimmer mb-2"></div>
                <div className="h-6 w-12 rounded skeleton-shimmer"></div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Calendar Grid Skeleton */}
      <div className="overflow-x-auto">
        <div className="min-w-full inline-block">
          {/* Calendar Header Skeleton */}
          <div className="flex border-b border-gray-200 sticky top-0 bg-white z-10 shadow-sm min-w-max">
            {/* Week Cell */}
            <div className="w-24 sm:w-28 md:w-36 flex-shrink-0 border-r border-gray-200 flex flex-col items-center justify-center bg-white px-1 py-2 sm:px-2 sm:py-2.5">
              <div className="h-3 w-12 rounded skeleton-shimmer mb-1"></div>
              <div className="h-4 w-20 rounded skeleton-shimmer"></div>
            </div>
            
            {/* Day Headers Skeleton */}
            {['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'].map((day, i) => (
              <div
                key={day}
                className="flex-1 flex flex-col items-center justify-center border-r border-gray-200 min-w-[140px] sm:min-w-[160px] md:min-w-[180px] py-2 sm:py-2.5 bg-white"
              >
                <div className="w-10 h-10 sm:w-11 sm:h-11 md:w-12 md:h-12 rounded-xl skeleton-shimmer mb-2"></div>
                <div className="h-4 w-16 rounded skeleton-shimmer"></div>
              </div>
            ))}
          </div>

          {/* Time Slots Skeleton */}
          <div className="flex min-w-max">
            {/* Time Column */}
            <div className="w-24 sm:w-28 md:w-36 flex-shrink-0 border-r border-gray-200 bg-gray-50">
              {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((i) => (
                <div
                  key={i}
                  className="h-40 border-b border-gray-200 flex items-center justify-center"
                >
                  <div className="h-4 w-12 rounded skeleton-shimmer"></div>
                </div>
              ))}
            </div>

            {/* Calendar Days Skeleton */}
            {[1, 2, 3, 4, 5, 6, 7].map((day) => (
              <div
                key={day}
                className="flex-1 min-w-[140px] sm:min-w-[160px] md:min-w-[180px] border-r border-gray-200 bg-white"
              >
                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((slot, i) => (
                  <div
                    key={slot}
                    className="h-40 border-b border-gray-200 relative"
                  >
                    {/* Random class blocks skeleton */}
                    {i % 3 === 0 && (
                      <div
                        className="absolute top-2 left-2 right-2 rounded-lg skeleton-shimmer"
                        style={{
                          height: `${80 + (i % 2) * 40}px`,
                          animationDelay: `${(day + slot) * 100}ms`,
                        }}
                      >
                        <div className="p-2">
                          <div className="h-3 w-20 rounded mb-1 skeleton-shimmer"></div>
                          <div className="h-2 w-16 rounded skeleton-shimmer"></div>
                        </div>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Loader;
